

































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import SuporteHospitaisRemuneracaoStore from '@/components/RemuneracaoMedica/suporte/store/SuporteHospitaisRemuneracaoStore'
import EventBus from '@/plugins/EventBus'
import { maskCPFCNPJ, maskDate, validateCNPJ } from '@/utils/common'
import ModalRemuneracaoSuporteHospital from './ModalRemuneracaoSuporteHospital.vue'
import ModalRemuneracaoSuporteEditarHospital from './ModalRemuneracaoSuporteEditarHospital.vue'
import ModalCadastroGrupoRepasse from './ModalCadastroGrupoRepasse.vue'

@Component({
  components: {
    ModalRemuneracaoSuporteHospital,
    ModalRemuneracaoSuporteEditarHospital,
    ModalCadastroGrupoRepasse,
  },
})
export default class ModalCadastroHospitais extends Vue {
  loadHospitais: boolean = false
  loadAddHospital: boolean = false
  loadEditHospital: string = ''
  loadModalGrupoRepasse: string = ''
  hospitalSearch: string = ''
  loadCnpj: boolean = false
  showModalCnpj: boolean = false
  exibirNome: boolean = false

  get getSuporteHospitaisRemuneracaoStore() {
    return getModule(SuporteHospitaisRemuneracaoStore, this.$store)
  }

  get getHospitais() { return this.getSuporteHospitaisRemuneracaoStore.hospitais }

  get loadingAddHospital() { return this.loadAddHospital }
  set loadingAddHospital(value: boolean) { this.loadAddHospital = value }

  get loadingEditHospital() { return this.loadEditHospital }
  set loadingEditHospital(value: string) { this.loadEditHospital = value }

  get loadingModalGrupoRepasse() { return this.loadModalGrupoRepasse }
  set loadingModalGrupoRepasse(value: string) { this.loadModalGrupoRepasse = value }

  get loadingCnpj() { return this.loadCnpj }
  set loadingCnpj(value: boolean) { this.loadCnpj = value }

  get loadingHospitais() { return this.loadHospitais }
  set loadingHospitais(value: boolean) { this.loadHospitais = value }

  get cnpjInput() { return this.getSuporteHospitaisRemuneracaoStore.cnpjInput }
  set cnpjInput(value: string) { this.getSuporteHospitaisRemuneracaoStore.setCnpjInput(value) }

  get nomeInput() { return this.getSuporteHospitaisRemuneracaoStore.nomeInput }
  set nomeInput(value: string) { this.getSuporteHospitaisRemuneracaoStore.setNomeInput(value) }

  get cepInput() { return this.getSuporteHospitaisRemuneracaoStore.cepInput }
  set cepInput(v: string) { this.getSuporteHospitaisRemuneracaoStore.setCepInput(v) }

  get bairroInput() { return this.getSuporteHospitaisRemuneracaoStore.bairroInput }
  set bairroInput(v: string) { this.getSuporteHospitaisRemuneracaoStore.setBairroInput(v) }

  get cidadeInput() { return this.getSuporteHospitaisRemuneracaoStore.cidadeInput }
  set cidadeInput(v: string) { this.getSuporteHospitaisRemuneracaoStore.setCidadeInput(v) }

  get numeroInput() { return this.getSuporteHospitaisRemuneracaoStore.numeroInput }
  set numeroInput(v: string) { this.getSuporteHospitaisRemuneracaoStore.setNumeroInput(v) }

  get logradouroInput() { return this.getSuporteHospitaisRemuneracaoStore.logradouroInput }
  set logradouroInput(v: string) { this.getSuporteHospitaisRemuneracaoStore.setLogradouroInput(v) }

  get complementoInput() { return this.getSuporteHospitaisRemuneracaoStore.complementoInput }
  set complementoInput(v: string) { this.getSuporteHospitaisRemuneracaoStore.setComplementoInput(v) }

  get ufInput() { return this.getSuporteHospitaisRemuneracaoStore.ufInput }
  set ufInput(v: string) { this.getSuporteHospitaisRemuneracaoStore.setUfInput(v) }

  get tipoEndereco() { return this.getSuporteHospitaisRemuneracaoStore.tipoEndereco }
  set tipoEndereco(v: string) { this.getSuporteHospitaisRemuneracaoStore.setTipoEndereco(v) }

  get tipoEmpresasMedicas() { return this.getSuporteHospitaisRemuneracaoStore.tipoEmpresasMedicas }

  get podeEnviarInclusao() {
    return !!(
      this.nomeInput &&
      this.cepInput &&
      this.bairroInput &&
      this.cidadeInput &&
      this.numeroInput &&
      this.logradouroInput &&
      this.complementoInput
    )
  }

  get getHospitaisTableHeader() {
    return [
      { text: 'Nome', class: 'table-headers', align: 'left', value: 'nome' },
      { text: 'Nome grupo', class: 'table-headers', align: 'left', value: 'nomeGrupo' },
      { text: 'CNPJ', class: 'table-headers', align: 'left', value: 'cnpj' },
      { text: 'Data início', class: 'table-headers', align: 'left', value: 'inicioUso' },
      { text: 'Ações', class: 'table-headers', value: '', align: 'center', sortable: false },
    ]
  }

  get showModalHospital() {
    return this.getSuporteHospitaisRemuneracaoStore.modal.hospital
  }

  set showModalHospital(value: boolean) {
    this.getSuporteHospitaisRemuneracaoStore.setModal({ name: 'hospital', value })
  }

  maskCnpj(cnpj: string) {
    return maskCPFCNPJ(cnpj)
  }

  maskDate(date: string) {
    return maskDate(date)
  }

  isValidCnpj(cnpj: string) {
    return validateCNPJ(cnpj)
  }

  async addHospital() {
    this.loadingAddHospital = true
    this.showModalCnpj = true
    this.loadingAddHospital = false
  }

  async editarHospital(item: any) {
    this.loadingEditHospital = item.id
    const request = await this.getSuporteHospitaisRemuneracaoStore.getHospitalById(item.id)
    if (request.success) {
      this.getSuporteHospitaisRemuneracaoStore.setModal({ name: 'criarHospital', value: true })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Ocorreu um erro na requisição.', icon: 'warning', color: '#C62828', timeout: 5500 })
    }
    this.loadingEditHospital = ''
  }

  closeModalCnpj() {
    this.showModalCnpj = false
    this.exibirNome = false
    this.getSuporteHospitaisRemuneracaoStore.clearVincularCnpj()
  }

  async showModalGrupoRepasse(item: any) {
    this.loadingModalGrupoRepasse = item.id
    this.getSuporteHospitaisRemuneracaoStore.setGrupoHospitalId(item.grupoHospitalId)
    this.getSuporteHospitaisRemuneracaoStore.setHospitalId(item.id)
    const request = await this.getSuporteHospitaisRemuneracaoStore.getGrupoRepasse()
    if (request.success) {
      this.getSuporteHospitaisRemuneracaoStore.setModal({ name: 'grupoRepasse', value: true })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Ocorreu um erro na requisição.', icon: 'warning', color: '#C62828', timeout: 5500 })
    }
    this.loadingModalGrupoRepasse = ''
  }

  async onConfirmarCnpj() {
    if (this.loadingCnpj) return
    this.loadingCnpj = true

    const cnpjSemMascara = (this.cnpjInput || '').replace(/[.\-/]/g, '')

    if (!this.isValidCnpj(cnpjSemMascara)) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'CNPJ inválido. Verifique e tente novamente.',
        icon: 'warning',
        color: '#C62828',
        timeout: 5500
      })
      this.loadingCnpj = false
      return
    }

    // Etapa 1: verificar CNPJ
    if (!this.exibirNome) {
      try {
        const request = await this.getSuporteHospitaisRemuneracaoStore.verifyCnpj()

        if (request.success) {
          this.getSuporteHospitaisRemuneracaoStore.setMode({ mode: 'CREATE' })
          this.getSuporteHospitaisRemuneracaoStore.setModal({ name: 'criarHospital', value: true })
          this.showModalCnpj = false
        } else {
          this.exibirNome = true
        }
      } catch (e) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: 'Erro ao verificar o CNPJ.',
          icon: 'warning',
          color: '#C62828',
          timeout: 5500
        })
      }
      this.loadingCnpj = false
      return
    }

    // Etapa 2: incluir novo CNPJ + dados obrigatórios
    const faltando: string[] = []
    if (!this.nomeInput) faltando.push('nome')
    if (!this.cepInput) faltando.push('CEP')
    if (!this.bairroInput) faltando.push('bairro')
    if (!this.cidadeInput) faltando.push('cidade')
    if (!this.numeroInput) faltando.push('número')
    if (!this.logradouroInput) faltando.push('logradouro')
    if (!this.complementoInput) faltando.push('complemento')

    if (faltando.length) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `Preencha: ${faltando.join(', ')}`,
        icon: 'warning',
        color: '#C62828',
        timeout: 5500
      })
      this.loadingCnpj = false
      return
    }

    try {
      const request = await this.getSuporteHospitaisRemuneracaoStore.createPessoaJuridica()

      if (request.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: 'CNPJ vinculado com sucesso.',
          icon: 'check',
          color: 'green',
          timeout: 4000
        })

        this.getSuporteHospitaisRemuneracaoStore.setMode({ mode: 'CREATE' })
        this.getSuporteHospitaisRemuneracaoStore.setModal({ name: 'criarHospital', value: true })
        this.closeModalCnpj()
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: request.message || 'Erro ao incluir o CNPJ.',
          icon: 'warning',
          color: '#C62828',
          timeout: 5500
        })
      }
    } catch (e) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Falha inesperada ao incluir o CNPJ.',
        icon: 'warning',
        color: '#C62828',
        timeout: 5500
      })
    }

    this.loadingCnpj = false
  }

  async closeModal() {
    await this.getSuporteHospitaisRemuneracaoStore.getGrupoHospital()
    this.getSuporteHospitaisRemuneracaoStore.clearHospitaisDetails()
    this.showModalHospital = false
  }
}
